import { AiOutlineDollar } from '@react-icons/all-files/ai/AiOutlineDollar';
import { FaTools } from '@react-icons/all-files/fa/FaTools';
import { FaHome } from '@react-icons/all-files/fa/FaHome';
import { FaRobot } from '@react-icons/all-files/fa/FaRobot';
import { FaHandshake } from '@react-icons/all-files/fa/FaHandshake';
import { FaPlayCircle } from '@react-icons/all-files/fa/FaPlayCircle';
import { HiOutlineDocumentReport } from '@react-icons/all-files/hi/HiOutlineDocumentReport';
import { FaStream } from '@react-icons/all-files/fa/FaStream';
import { FaCity } from '@react-icons/all-files/fa/FaCity';
import { GiProfit } from '@react-icons/all-files/gi/GiProfit';
import { Link } from 'react-router-dom';

const DEMO_ORGANIZATION_ID = '64a41befec71e9112cad2c7f';

export const getSidebarNavItems = (
  organizationId,
  isPreDealsTrainingWatched,
  managedMarketplace,
  isMissedOpportunitiesReportActive,
  isAllWaysCapital,
) =>
  [
    {
      icon: <AiOutlineDollar style={{ fontSize: '18px' }} />,
      label: <Link to="/">Dashboard</Link>,
    },
    {
      icon: <FaHome />,
      label: <Link to="/buybox">Buy Box</Link>,
    },
    {
      icon: <FaTools />,
      label: <Link to="/settings">Settings</Link>,
    },
    ...(managedMarketplace
      ? [
          {
            icon: <HiOutlineDocumentReport />,
            label: <Link to="marketplace-report">Admin Overview</Link>,
          },
        ]
      : []),
    ...(isPreDealsTrainingWatched
      ? [
          {
            icon: <FaPlayCircle />,
            label: <Link to="/pre-lock-how-it-works">Pre-lock Inventory™</Link>,
          },
        ]
      : []),
    ...(organizationId === DEMO_ORGANIZATION_ID
      ? [
          {
            icon: <FaRobot />,
            label: <Link to="/">AI Workflows</Link>,
          },
          {
            icon: <FaHandshake />,
            label: <Link to="/">Integrations</Link>,
          },
        ]
      : []),
    {
      icon: <FaStream />,
      label: <Link to="/entities">My entities</Link>,
    },
    {
      icon: <FaCity />,
      label: <Link to="/assets">My assets</Link>,
    },
    ...(isAllWaysCapital
      ? [
          {
            icon: <GiProfit />,
            label: (
              <a
                href="https://www.getzorba.com/investors/mark-abramovich"
                target="_blank"
                rel="noopener noreferrer"
              >
                Sell
              </a>
            ),
          },
        ]
      : []),
    ...(isMissedOpportunitiesReportActive
      ? [
          {
            icon: <GiProfit />,
            label: <Link to="/opportunities">Missed opportunities</Link>,
          },
        ]
      : []),
  ].map((navItem, index) => ({ ...navItem, key: (index + 1).toString() }));
